import { Injectable } from '@angular/core'
import { MbProductReviewsAdapter } from './mb-product-reviews.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbProductReviewsConnector {

  constructor (protected adapter: MbProductReviewsAdapter) {
  }

  get (productCode: string, maxCount?: number) {
    return this.adapter.load(productCode, maxCount)
  }
}
